import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'field';

export const TEST_ID = 'fieldSelectPanelField';
